



import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify'; // Import toast for success/error messages
import 'react-toastify/dist/ReactToastify.css'; // Import the CSS for Toast
import ManagerHeader from "./ManagerHeader";
import Navbar from "./Navbar";

const BulkUpload = () => {
  const [file, setFile] = useState(null);
  const navigate = useNavigate();

  // Token validation: check if token exists when the component mounts
  useEffect(() => {
    const token = localStorage.getItem('mangertoken');
    if (!token) {
      navigate('/ManagerLogin'); // Redirect to login if no token found
    }
  }, [navigate]);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async (event) => {
    event.preventDefault();

    if (!file) {
      toast.error("Please select a CSV file to upload.", {
        position: toast.POSITION.BOTTOM_CENTER, // Show toast at the bottom
      });
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await fetch("https://server-side-influencer.onrender.com/manager/managercsv", {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {
        toast.success("File uploaded successfully!", {
          position: toast.POSITION.BOTTOM_CENTER, // Show toast at the bottom
        });
      } else {
        toast.error(`Upload Failed: ${result.message || "Something went wrong."}`, {
          position: toast.POSITION.BOTTOM_CENTER, // Show toast at the bottom
        });
      }
    } catch (error) {
      toast.error("Network error: Unable to connect to server.", {
        position: toast.POSITION.BOTTOM_CENTER, // Show toast at the bottom
      });
    }
  };

  return (
    <div className="flex h-screen bg-white">
      {/* Sidebar (Navbar) */}
      <div className="text-white fixed top-0 left-0 bottom-0 z-20">
        <Navbar />
      </div>

      {/* Main content area */}
      <div className="ml-0 w-full">
        {/* Manager Header, set to appear behind the Navbar */}
        <div className="fixed top-0 left-0 right-0 z-10 bg-white shadow-md">
          <ManagerHeader page="Bulk Upload" />
        </div>

        {/* CSV Upload Section */}
        <div className="mt-10 flex flex-col items-center justify-center h-[calc(100vh-100px)]">
          {/* Title */}
          <h2 className="text-lg font-semibold mb-2">
            Upload Your Bulk CSV Data
          </h2>

          {/* Container for the button with large gradient border */}
          <div
            className="flex justify-center items-center w-[300px] sm:w-[400px] h-[150px] sm:h-[200px] p-4"
            style={{
              boxSizing: 'border-box',
              border: '4px solid',
              borderImage: 'linear-gradient(to right, #8B5CF6, #3B82F6) 1',
              borderRadius: '16px',
            }}
          >
            <form onSubmit={handleUpload} className="flex flex-col items-center w-full h-full justify-center">
              <input
                type="file"
                accept=".csv"
                onChange={handleFileChange}
                className="mb-4 p-2 border border-gray-300 rounded-lg w-full"
              />
              <button
                type="submit"
                className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
              >
                Upload CSV
              </button>
            </form>
          </div>

          {/* Small text below the button explaining the expected CSV headers */}
          <p className="mt-4 text-sm text-gray-600">
            Note: The CSV file should contain the following header values:
            <br />
            <code className="text-xs block mt-2 bg-gray-100 p-2 rounded-md">
              Name, InstagramProfile, Followers, YouTubeLink, Subscribers, Category, ContactNumber, Location, State, City, CostingPerSegment, Notes, Hashtags, ManagedBy, Lifestyle, Email, Commercial
            </code>
          </p>
        </div>
      </div>

      {/* Toast Notifications Containers */}
      <ToastContainer
        position={toast.POSITION.BOTTOM_CENTER} // Position the toasts at the bottom-centers
        autoClose={5000} // Auto close after 5 seconds
        hideProgressBar={true} // Hide progress bar
        newestOnTop={true} // Show newest toast on top
        closeOnClick={true} // Allow closing the toast by clicking
        rtl={false} // No RTL support needed here
      />
    </div>
  );
};

export default BulkUpload;
